import React, { useState, useEffect } from 'react';
import { Box, HStack, Text, Icon, Badge, Flex, Image, Heading } from '@chakra-ui/react';
import { FiActivity } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { authAPI, resolveImageUrl } from '../services/api';
import LogoPulseLoader from '../components/LogoPulseLoader';
import MarkdownContent from '../components/MarkdownContent';
import { formatDateTime } from '../utils/dateUtils';

// 統一用 dateUtils 強制以 Asia/Taipei 顯示
const fmtDateTime = formatDateTime;

const ParentAnnouncementDetailPage = () => {
    const { id } = useParams();
    const [ann, setAnn] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        let active = true;
        const load = async () => {
            try {
                const res = await authAPI.announcements.getMyDetail(id);
                if (!active) return;
                setAnn(res.data);
                // 開啟即回寫已讀（失敗不影響閱讀）
                authAPI.announcements.markRead(id, 'list').catch(() => {});
            } catch (e) {
                if (active) setNotFound(true);
            } finally {
                if (active) setLoading(false);
            }
        };
        load();
        return () => { active = false; };
    }, [id]);

    if (loading) {
        return <Flex justify="center" align="center" h="50vh"><LogoPulseLoader /></Flex>;
    }

    if (notFound || !ann) {
        return (
            <Flex direction="column" align="center" justify="center" h="50vh" color="onCanvas.300">
                <Icon as={FiActivity} boxSize={14} mb={3} />
                <Text>找不到這則公告</Text>
            </Flex>
        );
    }

    const cover = resolveImageUrl(ann.cover_image_url);

    return (
        <Box pb="calc(env(safe-area-inset-bottom) + 32px)">
            {cover && <Image src={cover} w="100%" maxH="220px" objectFit="cover" objectPosition={ann.cover_position || 'center'} alt="" />}
            {/* 【2026-08-18 user 回報「公告內文底色是綠色、字看不清楚」】
                原本標題與內文直接坐在外殼上，而外殼＝App 畫布 #8A9A7B（中間調綠）。
                改成用卡片承載，理由是這套配色的語意就是「畫布只做外層背景，內容一律放卡片上」——
                公告內文屬於內容，本來就不該直接鋪在畫布上。
                為什麼不是改成米白字：畫布對白字的對比只有 3.00，達不到 AA 小字門檻(4.5)，
                長篇內文用白字會很吃力；深色字在畫布上雖有 5.83，但又與其他頁面的卡片內文不一致。
                改底色一次解決可讀性與一致性兩件事。 */}
            <Box px={4} pt={4}>
                <Box bg="white" borderRadius="xl" boxShadow="sm" px={5} py={5}>
                    <HStack spacing={2} mb={2}>
                        {ann.is_emergency && <Badge colorScheme="red" borderRadius="full" px={2}>緊急</Badge>}
                    </HStack>
                    <Heading size="md" color="neutral.800" mb={2}>{ann.title}</Heading>
                    {/* 進了卡片就不能再用 onCanvas.*（那組是為畫布底調的），改用卡片內部的 neutral.* */}
                    <Text fontSize="xs" color="neutral.500" mb={4}>{fmtDateTime(ann.published_at || ann.created_at)}</Text>
                    {/* 內文支援 Markdown：圖片 + 可點連結（連結開外部瀏覽器） */}
                    <MarkdownContent content={ann.content} />
                </Box>
            </Box>
        </Box>
    );
};

export default ParentAnnouncementDetailPage;
